import type { FC } from 'react';

import { useTeamForm } from '../hooks/useTeamForm';
import { useTeamMutations } from '../hooks/useTeamMutations';
import type { TeamRecord } from '../types';
import { isTeamDisabled } from '../utils/get-team-status';
import { TeamFormModal } from '../views/TeamFormModal';

interface TeamFormModalControllerProps {
  handleClose: () => void;
  team?: TeamRecord;
}

export const TeamFormModalController: FC<TeamFormModalControllerProps> = ({ handleClose, team }) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isValid },
  } = useTeamForm(team?.name);
  const { onCreate, onRename, onSetStatus, isPending } = useTeamMutations({ onSettled: handleClose });

  const isDisabled = !!team && isTeamDisabled(team);
  const onSubmit = handleSubmit(({ name }) => (team ? onRename({ id: team.id, name }) : onCreate(name)));

  const onToggleStatus = () => team && onSetStatus({ id: team.id, status: isDisabled ? 'Active' : 'Disabled' });

  return (
    <TeamFormModal
      control={control}
      isDirty={isDirty}
      isDisabled={isDisabled}
      isEdit={!!team}
      isPending={isPending}
      isValid={isValid}
      onClose={handleClose}
      onSubmit={onSubmit}
      onToggleStatus={team ? onToggleStatus : undefined}
    />
  );
};
